import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import Layout from "../../components/layouts/layout.comp";
import SpecialistEditor from "../../components/specialist/specialistEditor.comp";
import { post } from "../../core/fetch.core";
import { useTranslation } from "../../core/translation.core";
import { SpecialistFormData } from "../../types/specialist";

export default function CreateSpecialistPage() {
  const { t, msg } = useTranslation();
  const methods = useForm<SpecialistFormData>();
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: SpecialistFormData) => {
      await post("/admin/specialist/create", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["specialists"] });
      push("/specialists");
    },
  });

  return (
    <Layout title={t(msg.specialist.add)}>
      <SpecialistEditor methods={methods} mutation={mutation} btnName={t(msg.form.create)} />
    </Layout>
  );
}
